<template>
    <div class="details purchase">
        <navbar></navbar>
        <steps :current="current"></steps>
        <div class="succeeds">
            <img src="../../assets/store/succeeds_icon.png" alt="">
            <p>{{$t('user_order_pay_success')}}</p>
            <router-link :to="{name: 'Ongoing'}">
                <p class="learn_order" style="color: #0084FF;font-size: 16px;margin-top: 10px;">{{$t('order_details')}} ></p>
            </router-link>
        </div>
        <listing :lists="order_detail" ></listing>

        <div class="order-payment details-width">
            <guess></guess>
        </div>
    </div>
</template>
<script>
    import navbar from '../Common/Navbar.vue'
    import steps from './Common/Steps.vue'
    import guess from '../Profiler/Common/Guess.vue'
    import Signature from '../../lib/Signature'
    import listing from './Common/Listing.vue'

    export default {
        data () {
            return {
                current: 2,
                value: '',
                show: false,
                tag: this.flag,
                order_info: {},
                order_detail: [],
                guessList: [
                    {
                        name: '产品名1这个可能要很长来甜酸我就是乱打哈哈哈哈',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 1
                    },
                    {
                        name: '这怎么能行呢',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 2
                    },
                    {
                        name: '产品名3',
                        img: '',
                        price: '110',
                        originalPrice: '$123',
                        id: 3
                    }
                ]
            }
        },
        components: {
            navbar,
            steps,
            guess,
            listing
        },
        props: {
            id: Number,
            checkedNum: {
                type: Number,
                default: 0
            },
            flag: {
                type: Number,
                default: 0
            }

        },
        created () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                if (!this.$route.query.order_sn) {
                    this.$Message.error(this.$t('user_message_order_is_null'))
                }
                let module = 'index.php/index/order/orderdetail'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.token = this.Local.getUserToken()
                if (!this.Local.get('users')) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.lang = this.$i18n.locale
                data.order_sn = this.$route.query.order_sn
                this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.order_info = response.data.data.order_info
                        this.order_info = response.data.data.order_info
                        this.order_detail = response.data.data.order_detail
                    }
                }.bind(this))
            },
            refreshGoods () {
//        猜你喜欢,删除下面的代码,使用后台数据
                this.guessList.sort(() => Math.random() > 0.5 ? -1 : 1)
            },
            checkRadio (index, e) {
                this.tag = index
                if (e.target.nodeName === 'INPUT') {
                    this.tag = index
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/common";

    .details-width {
        margin: 0 auto;
        width:90%;
        max-width:1240px;
    }
    @media screen and (max-width: 500px){
        .profile-title{
            font-size:30px !important;
        }
    }

    .details {

        text-align: left;
        margin-top: 100px;
        @at-root .profile-title {
            font-weight: 500;
            font-size: 50px;
            color: #1F2D3D;
            text-align: left;
        }
        .order-payment {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            margin-bottom: 100px;
            line-height: 24px;
            .pay-left {
                line-height: 2;
                h3 {
                    font-size: 24px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 26px;
                }
                .pay-method {

                }
            }
            .pay-right {
                color: #5E6D82;
                text-align: right;
                .real-pay {
                    font-size: 24px;
                }
            }
        }
    }

    .text-primary {
        color: #0084FF;
    }
    .order-group{
        table{
            margin: 0 auto;
        }
        .order-list {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 20px;
        .order-group-header {
            .ivu-col {
                font-size: 14px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }
        }
        .listing {
            font-size: 24px;
            color: #1F2D3D;
            letter-spacing: 0;
            line-height: 26px;
            font-weight: 400;
        }
        .order-content {
            background: #F9FCFF;
            padding: 20px 0;
            margin-bottom: 100px;
        & > div {
                max-width: $body-width;
                margin: 0 auto;
            }
        .order-col {
            height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            h3 {
                font-size: 16px;
            }
        }

            .order-col-title {
                font-size: 24px;
            }
        }
            .order-group-list {
                .order-number {
                    color: #5E6D82;
                    font-weight: normal;
                    font-size: 16px;
                    letter-spacing: 0;
                    line-height: 24px;
                    margin-top: 10px;
                }
            }
        }
    }


    .purchase {
        .succeeds {
            text-align: center;
            padding: 3% 0 5% 0;
        }
        .succeeds p {
            font-size: 24px;
            margin-top: 15px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 26px;
        }
    }

</style>



// WEBPACK FOOTER //
// PurchaseSucceeds.vue?3bd4e04d